import {Routes, Route, Link} from 'react-router-dom';

export default function Landing () {
    return (
        <div id="landingMain">
            <div className="row" id="name">
                <div className="col">JAY "KURZWEIL" OYEBADEJO</div>
            </div>
            <div className="row nav">
                <div className="col-4">
                    <Link to={"all-works"}><span>WORKS</span></Link>
                </div>
                <div className="col-4">
                    <Link to={"booking"}><span>BOOKING</span></Link>
                </div>
                <div className="col-4">
                    {/* <Link to={"all-works"}><span>CONTACT</span></Link> */}
                    <a href="mailto:jay@krzwlmusic.com">CONTACT</a>
                </div>
            </div>
        </div>

    )
}